module.exports = __webpack_public_path__ + "static/img/logo.0a5ecb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sfy/logo.png
// module id = +VaK
// module chunks = 2